import { action } from 'easy-peasy';
import { Status } from '~/services/api/actTeamMember/types';
import { IActionActivateTeamMember } from '../types';

const activateTeamMember: IActionActivateTeamMember = action((state, teamMemberId) => {
  const updatedList = state.list.map(item =>
    item.id !== teamMemberId ? item : { ...item, status: 'Active' as Status },
  );

  state.list = updatedList;
});

export default activateTeamMember;
